import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateReadActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";

export default {
    readAll: generateReadActionCreator(routes.API_QUOTES_AND_ORDERS, ACTION_NAMES.QUOTES_AND_ORDERS),
    readPowerSelectors: generateReadActionCreator(routes.API_QUOTES_AND_ORDERS_POWER_SELECTORS, ACTION_NAMES.QUOTES_AND_ORDERS_POWER_SELECTORS)
}
